export default "__VITE_ASSET__MSwPKcuu__"